import {email, required, sameAs} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core/dist/index.esm";
import {mixins} from "./app/mixin";

const fileSizeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const file = value
    return file.size < 5242880
}

const fileTypeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const fileName = value.name
    const pattern = /\.(pdf|docx|doc)$/
    return pattern.test(fileName)
}

mixins.push({
    el: '.legalTermsPage',
    delimiters: ['${', '}'],
    validations: {
        fullName: {required},
        organization: {required},
        email: {required, email},
        isTermsApproved1: {required, sameAs: sameAs(true)},
        isTermsApproved2: {required, sameAs: sameAs(true)},
        file1: {required, fileSizeValidation, fileTypeValidation},
        file2: {fileSizeValidation, fileTypeValidation},
        file3: {fileSizeValidation, fileTypeValidation},
        feedbackType: {required},
    },
    data() {
        return {
            v: useVuelidate(),
            API: window.api,
            documentId: window.documentId,
            errorMessages: window.errorMessages,
            isVisible: false,
            fullName: '',
            email: '',
            organization: '',
            isTermsApproved1: false,
            isTermsApproved2: false,
            file1: null,
            file2: null,
            file3: null,
            feedbackType: '',
            status: '',
            lang: window.lang,
            isOpen: false,
            isFormOpen: false,
            isSubmitting: false,
            currentTab: 'policy'
        };
    },
    mounted() {
        document.addEventListener('click', (e) => {
            if (
                this.isOpen &&
                !e.target.classList.contains('menuLabel') &&
                !e.target.classList.contains('documentTitle') &&
                !e.target.classList.contains('arrowDown')
            ) {
                e.stopPropagation();
                this.toggleAccordion();
            }
        })
    },
    computed: {
        isButtonDisabled() {
            return this.v.$invalid
        },
        errorMessage() {
            let fullName, phone, email, feedbackType, organization, file1, file2;
            if (this.v.fullName.$error) {
                fullName = this.errorMessages.required
            }
            if (this.v.email.$error) {
                if (this.email.length === 0) {
                    email = this.errorMessages.required
                } else if (this.v.email.$error) {
                    email = this.errorMessages.emailIsInvalid
                }
            }
            if (this.v.feedbackType.$error) {
                feedbackType = this.errorMessages.required
            }
            if (this.v.organization.$error) {
                organization = this.errorMessages.required
            }
            if (this.v.file1.$error) {
                if (!this.v.file1.required.$response) {
                    file1 = this.errorMessages.required
                }
            }
            if (this.v.file1.fileTypeValidation.$invalid) {
                file1 = this.errorMessages.fileTypeValidation
            }
            if (this.v.file1.fileSizeValidation.$invalid) {
                file1 = this.errorMessages.fileSizeValidation
            }
            if (this.v.file2.fileTypeValidation.$invalid) {
                file2 = this.errorMessages.fileTypeValidation
            }
            if (this.v.file2.fileSizeValidation.$invalid) {
                file2 = this.errorMessages.fileSizeValidation
            }
            return {
                fullName,
                phone,
                email,
                feedbackType,
                organization,
                file1,
                file2
            }
        }
    },
    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen;
        },
        toggleForm() {
            this.isFormOpen = !this.isFormOpen;
        },
        selectTab(tabId) {
            this.currentTab = tabId;
        },
        closeFile(fileName) {
            console.log(fileName);
            this[fileName] = null;

            if (this.$refs[fileName]) {
                this.$refs[fileName].value = null;
            }
        },
        setFile1(e) {
            this.$emit('input', e.target.files[0])
            this.file1 = this.$refs.file1.files[0]
            this.v.file1.$touch()
        },
        setFile2(e) {
            this.$emit('input', e.target.files[0])
            this.file2 = this.$refs.file2.files[0]
            this.v.file2.$touch()
        },
        setFile3(e) {
            this.$emit('input', e.target.files[0])
            this.file3 = this.$refs.file3.files[0]
            this.v.file3.$touch()
        },
        async sendFeedback() {
            this.v.$touch()

            if (!this.v.$invalid && this.isTermsApproved1 && this.isTermsApproved2) {

                this.isSubmitting = true;

                try {
                    const requestObject = {
                        fullName: this.fullName,
                        email: this.email,
                        organization: this.organization,
                        feedbackType: this.feedbackType,
                        documentId: this.documentId
                    }

                    const response = await fetch(`${this.API}/feedback-applications`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.lang
                        },
                        body: JSON.stringify(requestObject)
                    })

                    if (response.status === 201) {
                        const data = await response.json();

                        const formData = new FormData();
                        if (this.file1) formData.append('primaryDocumentFile', this.file1);
                        if (this.file2) formData.append('secondaryDocumentFile', this.file2);
                        if (this.file3) formData.append('tertiaryDocumentFile', this.file3);

                        try {
                            const uploadUrl = `${this.API}/feedback-applications/${data.id}/upload`
                            const uploadResponse = await fetch(uploadUrl, {
                                method: "POST",
                                body: formData
                            });

                            if (uploadResponse.status === 201 || uploadResponse.status === 200) {
                                this.status = 'SUCCESS';
                                this.isVisible = true;
                                this.resetForm();
                            } else {
                                console.error('File upload error:', uploadResponse);
                                throw new Error('File upload error');
                            }
                        } catch (error) {
                            console.error('Error in uploadFile:', error);
                            this.status = 'ERROR';
                        } finally {
                            setTimeout(() => {
                                this.status = '';
                                this.isVisible = false;
                            }, 15000);
                        }
                    } else {
                        console.error('Feedback error:', response);
                        throw new Error('Feedback error');
                    }
                } catch (error) {
                    console.error('Error in sendFeedback:', error);
                    this.status = 'ERROR';
                } finally {
                    setTimeout(() => {
                        this.status = '';
                    }, 15000);
                    this.isSubmitting = false;
                }
            }
        },
        resetForm() {
            if (this.$refs.file1) {
                this.$refs.file1.value = '';
            }
            if (this.$refs.file2) {
                this.$refs.file2.value = '';
            }
            if (this.$refs.file3) {
                this.$refs.file3.value = '';
            }
            this.file1 = null;
            this.file2 = null;
            this.file3 = null;
            this.fullName = '';
            this.email = '';
            this.organization = '';
            this.feedbackType = '';
            this.isTermsApproved1 = false;
            this.isTermsApproved2 = false;
            this.v.$reset();

            window.scrollTo(0, document.documentElement.scrollTop +
                document.querySelector('.dropdown-form-container').getBoundingClientRect().top);
        },
    }
});